"use client";

import * as Sentry from "@sentry/nextjs";
import NextError from "next/error";
import { useEffect } from "react";
import {
  isStaleChunkError,
  routeErrorRecoveryHref,
  shouldReloadRouteErrorOnce,
} from "@/lib/stale-chunk";

export default function GlobalError({
  error,
}: {
  error: Error & { digest?: string };
}) {
  useEffect(() => {
    if (isStaleChunkError(error)) {
      const recoveryHref = routeErrorRecoveryHref(window.location.href);
      if (
        recoveryHref &&
        shouldReloadRouteErrorOnce(
          error,
          window.location.pathname,
          window.sessionStorage,
        )
      ) {
        window.location.replace(recoveryHref);
      }
      return;
    }
    Sentry.captureException(error);
  }, [error]);

  return (
    <html lang="en">
      <body>
        {/* `NextError` is the default Next.js error page component. Its type
        definition requires a `statusCode` prop. However, since the App Router
        does not expose status codes for errors, we simply pass 0 to render a
        generic error message. */}
        <NextError statusCode={0} />
      </body>
    </html>
  );
}
